 <template>
  <div :class="['onePage']">
    <div
      alt=""
      :class="['oneIconPng', oneTitShow ? 'imgAnimated imgFadeIn' : 'bgGray']"
    ></div>
    <div class="bottom"></div>
    <!-- 白底 + 边框  文字-->
    <div class="titHeader oneAnimated titShow" v-if="oneTitShow">
      感恩自然至德，至于生态之道 <span class="circle circleOne"></span>
      <span class="circle"></span>
    </div>
    <!-- <h4 :class="['title']">
        感恩自然至德，至于生态之道
      </h4> -->
    <div class="titBox">
      <!-- 初始版 现换成白底 边框显示 -->
      <!-- <h4 :class="['tit', oneTitShow ? 'oneAnimated' : '']">
        感恩自然至德，至于生态之道
      </h4> 
      <p class="textMian animated fadeIn" v-if="pageAction">
        2015年1月公司名称正式变更为东华（安徽）生态规划院有限公司，正式开启林业规划设计调查服务。
      </p>-->
      <p class="textMian animated delay fadeIn " v-if="oneTitShow">
        我院是一家从事自然生态规划设计的专业技术服务机构，服务的客户遍布安徽、江苏、浙江、河南、广东、和江西等11个省，我们立志做生态文明的践行者、传播者。
      </p>
    </div>
    <div class="bwBox" v-if="oneBtnShow" @click="changeHue">
      <div class="wave wave4"></div>
      <div class="wave wave3"></div>
      <div class="wave wave1"></div>
      <div class="wave waveOne">
        <!-- <img :src="baseUrl + 'img/dhShare/dianOne.png'" class="textAmation" /> -->
        <img :src="baseUrl + 'img/dhShare/dianIcon.png'" class="textAmation" />
      </div>
    </div>
  </div>
</template>
<script>
import "@/assets/style/animate.min.less";
export default {
  name: "onePage",
  props: {
    landscapeType: {
      type: Boolean,
      default: false,
    },
    newIndex: {
      type: String,
    },
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      typePage: false,
      oneTitShow: false,
      pageAction: false,
      oneBtnShow: true,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.typePage = this.landscapeType;
      this.initPage();
    });
  },
  methods: {
    initPage() {
      this.pageAction = true;
    },

    changeHue() {
      this.oneBtnShow = false;
      this.oneTitShow = true;
    },
  },
  watch: {
    landscapeType: function (newVal) {
      this.typePage = newVal;
    },
    newIndex: function (newValue) {
      if (newValue == "0") {
        this.pageAction = true;
      } else {
        this.pageAction = false;
      }
    },
  },
};
</script>
<style lang="less">
.onePage {
  width: 100%;
  height: 100%;
  font-family: "PingFang SC";
  background-image: url("../../../../../public/img/dhShare/slideOne.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  position: relative;
  font-family: "PingFangSC-Regular", "PingFang SC";
  .oneIconPng {
    width: 100%;
    height: 100%;
    background-image: url("../../../../../public/img/dhShare/oneIcon.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    z-index: 3;
    position: relative;
    -webkit-filter: grayscale(100%);
    /* Chrome, Safari, Opera */
    filter: grayscale(100%);
  }
  .bottom {
    width: 100%;
    height: 100%;
    background-image: url("../../../../../public/img/dhShare/bottomIcon.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    z-index: 99;
    -webkit-filter: grayscale(0);
    /* Chrome, Safari, Opera */
    filter: grayscale(0);
    position: absolute;
    top: 0;
    left: 0;
  }
  .titHeader {
    top: 150px;
    right: -35px;
    border: 1px solid #fff;
    color: #fff;
    .circle {
      border: 1px solid #fff;
    }
  }

  .titBox {
    position: absolute;
     top: 70px;
    right: 90px;
    //   position: absolute;
    //   bottom: 150px;
    //   right: 0px;
      z-index: 999;

    
    .textMian {
      width: 240px;
      position: absolute;
      top:0;
      left: 0;
      font-size: 12px;
      color: #fff;
      text-align: justify;
      opacity: 0;
      z-index: 999;
    }
  }
  .oneAnimated {
    animation: bounceInUp 2s forwards linear;
    /* Safari 和 Chrome */
  }
  // .bwBox {
  //   // top: 120px;
  //   // right: 65px;
  //   .wave,
  //   .wave1,
  //   .wave3,
  //   .wave4 {
  //     border: 1px solid #fba25e;
  //     color: #fba25e;
  //   }
  // }
}
</style>